import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./coach-landing.css";
import { trackCoachCtaClick } from "../../analytics/googleAnalytics";
import { segmentoCoach } from "./segmentoCoach";

/**
 * «Para quién»: una tarjeta por perfil, como las «Soluciones» de Harbiz
 * (entrenadores, centros, nutrición, fisio). Son los mismos segmentos de la
 * captación por correo, y la tarjeta de quien llega desde ese correo sale
 * destacada.
 *
 * Solo lo que el panel hace de verdad. ⛔ Nada de reservas ni de cobrar dentro
 * de la app: no existen.
 */
const PERFILES = [
  {
    id: "coach",
    segmentos: ["coach"],
    titulo: "Entrenadores personales y online",
    texto: "Se acabaron los PDF, el Excel y el Drive. Cada cliente con su plan en su móvil.",
    puntos: ["Rutinas con el vídeo de cada ejercicio", "Plan de nutrición con IA", "Ficha y progreso de cada cliente", "Chat con cada cliente"],
  },
  {
    id: "centro",
    segmentos: ["box", "centro"],
    titulo: "Boxes, centros y estudios",
    texto: "Publicad vuestras rutinas y vuestro contenido dentro de la app para los socios.",
    puntos: ["Programas y rutinas para los socios", "Clases grabadas y guías en la app", "Seguimiento de cada socio", "Da igual cuántos socios tengáis"],
  },
  {
    id: "nutri",
    segmentos: ["salud"],
    titulo: "Nutricionistas",
    texto: "Planes de comidas con las calorías y los macros ya calculados.",
    puntos: ["Menús con cantidades por comida", "Tu paciente registra lo que come con una foto", "Su peso y su objetivo de un vistazo", "Guías y recetarios en su app"],
  },
  {
    id: "fisio",
    segmentos: ["salud"],
    titulo: "Fisioterapeutas",
    texto: "Las pautas de ejercicios para casa, con vídeo, en el móvil del paciente.",
    puntos: ["Programas de ejercicios con vídeo", "Guías y PDF para el paciente", "Seguimiento entre sesiones", "Chat con cada paciente"],
  },
];

export default function CoachLandingSegmentos() {
  const [segmento] = useState(segmentoCoach);

  return (
    <section className="segmentos-section" id="para-quien">
      <div className="container">
        <div className="segmentos-header">
          <div className="section-tag">Para quién es</div>
          <h2 className="section-title">Un software, cuatro formas de trabajar</h2>
        </div>
        <div className="segmentos-grid">
          {PERFILES.map((p) => (
            <div key={p.id} className={`segmento-card${segmento && p.segmentos.includes(segmento) ? " is-destacado" : ""}`}>
              <h3>{p.titulo}</h3>
              <p>{p.texto}</p>
              <ul>
                {p.puntos.map((punto) => (
                  <li key={punto}>{punto}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 36 }}>
          <Link
            to="/coach/register"
            className="btn-primary"
            onClick={() => trackCoachCtaClick("coach_landing_segmentos")}
          >
            Crear mi cuenta gratis →
          </Link>
        </div>
      </div>
    </section>
  );
}
